export class RecruitmentRequest{
    recruitmentId:number;
    
    constructor(recruitmentId:number){
        this.recruitmentId = recruitmentId;
    }
}